module.exports = __webpack_public_path__ + "img/dataBoardSetting.b4d470a7.svg";